module.exports = __webpack_public_path__ + "images/CC_Logos_Logo_V2.svg";